<template>
  <cus-dialog>
    <template v-slot:body>
      <div class="wrap">
        <div class="img"><img :src="image" alt="" width="80" height="80" /></div>
        <p class="text" v-html="text"></p>
        <p v-if="cusProps?.canEnter" class="enter" @click="openInput">{{ cusProps?.canEnterText }}</p>
      </div>
    </template>
    <template v-slot:footer>
      <cus-button
        v-if="!style.hideFooter"
        :text="style.confirmButtonText || '關閉'"
        color="blue"
        @click="submit"
      ></cus-button>
    </template>
  </cus-dialog>
</template>
<script>
import { inject, watch } from 'vue';
import { useActions } from '@/utils/mapStore';
export default {
  name: 'alert',
  setup() {
    const dialogVisible = inject('dialogVisible');
    const name = inject('name');
    const text = inject('content');
    const image = inject('image');
    const submit = inject('submit');
    const close = inject('close');
    const { style } = inject('style');
    const { cusProps } = inject('cusProps');
    //關閉掃描
    const doCancelScan = useActions('member', ['doCancelScan']);
    // const doCancelCheckout = useActions('checkout', ['doCancelCheckout']);
    // watch(dialogVisible, () => {
    //   console.log('dialogVisible status=' + dialogVisible.value );
    //   if (name.value === 'noticeScan') {
    //     console.log('noticeScan doCancelScan');
    //     doCancelScan(cusProps.scanType);
    //   }
    //   else if (name.value === 'checkoutScan' || name.value === 'checkoutThirdPartyScan')
    //     doCancelCheckout(cusProps.order_id);
    // });
    //手動輸入
    const openInput = async () => {
      console.log('noticeScan doCancelScan openInput');
      await doCancelScan(cusProps.scanType);
      submit(cusProps.scanType);
    };
    return { name, text, image, close, submit, style, cusProps, openInput };
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  margin-top: 20px;
  display: grid;
  grid-template-rows: 110px auto;
  align-items: center;
  .img {
    margin: 0 auto;
  }
  .text {
    text-align: center;
    font-size: 2.4rem;
    color: $color-blue;
  }
  .enter {
    font-size: 2.4rem;
    color: $color-green;
    text-align: center;
    border-bottom: 1.5px solid $color-green;
    font-weight: 500;
    cursor: pointer;
    margin: 0 auto;
  }
}
</style>
